var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRuler = function SvgIconRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.294 9.027 9.113 22.208l-5.14-4.75 12.18-13.181zM16.723 8.817 14.52 6.781M14.686 11.02l-2.203-2.036M12.651 13.223l-2.203-2.036M10.614 15.427l-2.203-2.036M8.579 17.63l-2.204-2.036"
  }))));
};
export default SvgIconRuler;